import React, { useState } from "react";
import ModalVideo from "react-modal-video";
import QuoteImage from "../../assets/images/media/quote-image.png";

const FancyTextBlock21 = () => {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <div className="row align-items-center">
        <div
          className="col-lg-6 col-md-7 m-auto"
          data-aos="fade-right"
          data-aos-duration="1200"
        >
          <div className="img-meta">
            <img src={QuoteImage} alt="media" className="m-auto" />
            <img
              src="images/shape/138.svg"
              alt="shape"
              className="shapes shape-one"
            />
          </div>
        </div>
        {/* End .col */}

        <div
          className="col-xl-5 col-lg-6 ml-auto"
          data-aos="fade-left"
          data-aos-duration="1200"
          data-aos-delay="100"
        >
          <div className="text-wrapper md-pt-50">
  {/*    <a className="fancybox" onClick={() => setOpen(true)}>
              <img src="images/icon/71.svg" alt="icon" className="icon" />
            </a>
*/}
            <div className="client-info">
              Legacy monolithic platforms like <span>Magento, Shopify, Opencart</span> restrict business expansion.
            </div>
            <p>
            By 2023, organizations that have adopted a headless commerce approach will outpace competition by <span>80%</span> in the speed of new feature implementation.
            </p>
            <div className="name">Gartner 2020</div>
          </div>
          {/* /.text-wrapper */}
        </div>
        {/* End .col */}
      </div>

      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="FDaF8_5dzzk"
        onClose={() => setOpen(false)}
      />
    </>
  );
};

export default FancyTextBlock21;
